import React from 'react';
import { Helmet } from 'react-helmet';

const BlogYesBankPenalty = () => {
    const containerStyle = {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
        padding: '40px',
        backgroundColor: '#ffffff',
        borderRadius: '10px',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
        maxWidth: '800px',
        margin: '100px auto 20px auto',
        fontFamily: 'Arial, sans-serif',
    };

    const titleStyle = {
        fontSize: '28px',
        fontWeight: 'bold',
        color: '#333',
        marginBottom: '40px',
        textAlign: 'left',
        position: 'relative',
        display: 'inline-block'
    };

    const underlineStyle = {
        position: 'absolute',
        bottom: '-30px',
        left: '0',
        width: '100%',
        height: '20px',
        backgroundImage: 'url(https://res.cloudinary.com/dyrn2eg1j/image/upload/v1742880435/Financial-Underline_s5hilj.webp)',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain'
    };

    const sectionStyle = {
        marginBottom: '20px',
    };

    const headingStyle = {
        fontSize: '24px',
        fontWeight: 'bold',
        color: '#007BFF',
        marginBottom: '10px',
        textAlign: 'left',
        borderBottom: '3px solid #007BFF',
        display: 'inline-block',
        paddingBottom: '6px'
    };

    const paragraphStyle = {
        fontSize: '16px',
        lineHeight: '1.6',
        color: '#555',
        marginBottom: '10px',
        textAlign: 'left',
    };

    const imageStyle = {
        width: '100%',
        height: '300px',
        objectFit: 'cover',
        borderRadius: '8px',
        marginBottom: '15px',
    };

    const listStyle = {
        fontSize: '16px',
        lineHeight: '1.6',
        color: '#555',
        marginBottom: '10px',
        textAlign: 'left',
        paddingLeft: '20px',
        listStyleType: 'disc',
    };

    const ctaButtonStyle = {
        display: 'inline-block',
        padding: '12px 24px',
        backgroundColor: '#ff0101',
        color: '#ffffff',
        fontSize: '16px',
        fontWeight: 'bold',
        textDecoration: 'none',
        borderRadius: '5px',
        marginTop: '20px',
        transition: 'background-color 0.3s ease',
    };

    return (
        <>
            <Helmet>
                <title>RBI’s Yes Bank Penalty: Learn Trading with Stock Archery’s Courses in Bihar</title>
                <meta name="description" content="Understand the RBI’s ₹29.6 lakh penalty on Yes Bank and its market impact with Stock Archery’s stock market courses in Bihar and Bhagalpur. Join our trading classes to master investment strategies. Enroll today!" />
                <meta name="keywords" content="trading classes near me, stock market course Bihar, trading class Bihar, trading class Bhagalpur, stock market Bhagalpur, stock market classes, Stock Archery, Yes Bank penalty, RBI fine" />
                <meta name="robots" content="index, follow" />
                <meta name="author" content="Stock Archery" />
                <meta property="og:title" content="RBI’s Yes Bank Penalty: Stock Market Courses in Bihar | Stock Archery" />
                <meta property="og:description" content="Learn to navigate market reactions to events like the RBI’s Yes Bank penalty with Stock Archery’s trading classes in Bihar and Bhagalpur. Start your investment journey now!" />
                <meta property="og:image" content="https://res.cloudinary.com/dyrn2eg1j/image/upload/v1747644865/images_1_ikv34v.png" />
                <meta property="og:url" content="https://www.stockarchery.in" />
                <meta property="og:type" content="website" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="RBI’s Yes Bank Penalty: Stock Market Courses in Bihar | Stock Archery" />
                <meta name="twitter:description" content="Master trading strategies for events like the RBI’s Yes Bank penalty with Stock Archery’s stock market courses in Bihar and Bhagalpur. Enroll now!" />
                <meta name="twitter:image" content="https://res.cloudinary.com/dyrn2eg1j/image/upload/v1747644865/images_1_ikv34v.png" />
                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "Course",
                        "name": "Stock Market Courses by Stock Archery",
                        "description": "Expert-led stock market courses in Bihar and Bhagalpur, teaching trading strategies to navigate market events like the RBI’s Yes Bank penalty.",
                        "provider": {
                            "@type": "Organization",
                            "name": "Stock Archery",
                            "sameAs": "https://www.stockarchery.in",
                            "address": {
                                "@type": "PostalAddress",
                                "addressLocality": "Bhagalpur",
                                "addressRegion": "Bihar",
                                "addressCountry": "IN"
                            }
                        },
                        "image": "https://res.cloudinary.com/dyrn2eg1j/image/upload/v1747644865/images_1_ikv34v.png",
                        "offers": {
                            "@type": "Offer",
                            "priceCurrency": "INR",
                            "availability": "https://schema.org/InStock"
                        }
                    })}
                </script>
            </Helmet>
            <div style={containerStyle}>
                <h1 style={titleStyle}>
                    RBI’s Yes Bank Penalty: Invest Smart with Stock Archery
                    <div style={underlineStyle}></div>
                </h1>

                <div style={sectionStyle}>
                    <p style={paragraphStyle}>
                        The Reserve Bank of India (RBI) imposed a ₹29.6 lakh penalty on Yes Bank on May 17, 2025, for regulatory lapses, impacting its stock performance and investor confidence. At Stock Archery, our stock market courses in Bihar and Bhagalpur teach you how to navigate such market events. Join our trading classes near you to master investment strategies.
                    </p>
                    <img
                        src="https://res.cloudinary.com/dyrn2eg1j/image/upload/v1747644865/images_1_ikv34v.png"
                        alt="RBI Yes Bank Penalty 2025"
                        style={imageStyle}
                    />
                </div>

                <div style={sectionStyle}>
                    <h2 style={headingStyle}>📜 Why the Penalty?</h2>
                    <p style={paragraphStyle}>
                        The RBI’s fine, under the Banking Regulation Act, 1949, stems from a Statutory Inspection for Supervisory Evaluation (ISE) of Yes Bank’s financials as of March 31, 2022. Issues in customer onboarding, due diligence, and loan disbursements were flagged, though no fraud was involved. Our trading classes in Bihar help you analyze such regulatory impacts.
                    </p>
                    <p style={paragraphStyle}>Key issues found:</p>
                    <ul style={listStyle}>
                        <li>Loans sanctioned and disbursed without proper checks.</li>
                        <li>Customer complaints not handled within required timelines.</li>
                        <li>Violation of lending limits and exposure norms.</li>
                    </ul>
                </div>

                <div style={sectionStyle}>
                    <h2 style={headingStyle}>⚖️ RBI’s Take</h2>
                    <p style={paragraphStyle}>
                        The RBI emphasized that the penalty targets regulatory lapses, not customer transactions, allowing Yes Bank to operate normally while urging better compliance. Learn to assess such events with our stock market courses in Bhagalpur.
                    </p>
                    <ul style={listStyle}>
                        <li>No restrictions on daily operations.</li>
                        <li>A call to strengthen internal governance.</li>
                    </ul>
                </div>

                <div style={sectionStyle}>
                    <h2 style={headingStyle}>🏦 Yes Bank’s Comeback Struggle</h2>
                    <p style={paragraphStyle}>
                        Since the 2020 crisis, Yes Bank has been rebuilding with new leadership and a cleaner loan book. However, this penalty highlights ongoing governance challenges. Our trading classes in Bihar teach you how to evaluate a bank’s recovery potential.
                    </p>
                    <img
                        src="https://res.cloudinary.com/dyrn2eg1j/image/upload/v1747644865/rbi-agencies_uwo1h6.webp"
                        alt="Yes Bank Recovery Efforts"
                        style={imageStyle}
                    />
                    <p style={paragraphStyle}>Recent steps include:</p>
                    <ul style={listStyle}>
                        <li>New leadership to steer the ship.</li>
                        <li>Fixing the loan portfolio to cut risks.</li>
                        <li>Working to rebuild market and investor confidence.</li>
                    </ul>
                </div>

                <div style={sectionStyle}>
                    <h2 style={headingStyle}>📈 Investor and Market Impact</h2>
                    <p style={paragraphStyle}>
                        The penalty triggered stock volatility, with investors cautious about governance gaps. While the fine is small, it underscores compliance risks. Our stock market courses in Bhagalpur help you track key metrics to make informed investment decisions.
                    </p>
                    <ul style={listStyle}>
                        <li>Track CASA ratios, credit quality, and ROA/ROE metrics.</li>
                        <li>Listen for management’s take on compliance in earnings calls.</li>
                        <li>Watch how the bank boosts its compliance culture.</li>
                    </ul>
                </div>

                <div style={sectionStyle}>
                    <h2 style={headingStyle}>Learn to Navigate Markets with Stock Archery</h2>
                    <p style={paragraphStyle}>
                        Ready to master trading during market events like the RBI’s Yes Bank penalty? Join Stock Archery’s trading classes near you in Bihar and Bhagalpur. Our stock market courses cover market analysis, risk management, and trading strategies, empowering beginners and advanced traders. Enroll in our trading class in Bihar or Bhagalpur today!
                    </p>
                    <a href="https://www.stockarchery.in" style={ctaButtonStyle}>Join Our Stock Market Courses Now</a>
                </div>
            </div>
        </>
    );
};

export default BlogYesBankPenalty;